import api from './api';

// NOTE: the shared axios instance (`services/api.ts`) is configured with
// baseURL = config.API_URL, which already includes the `/api/v1` prefix.
// Paths here are relative to that prefix.
const BASE = '/scac-info';

export interface ContactBlock {
  key: string;
  label: string;
  phone: string;
  email: string;
  contact: string;
  fax: string;
  website: string;
  other: string;
  instructions: string;
  railbillFlag: string | null;
}

export interface RpCyLocation {
  railPort: string;
  cy: string;
  other: string;
}

export interface ScacLocationInfo {
  location: string;
  scacName: string;
  scac: string;
  website: string;
  preferredChassisProvider: string;
  chassisPool: string;
  notes: string;
  rpCyLocations: RpCyLocation[];
  contacts: ContactBlock[];
}

export interface ScacInfoResponse {
  scac: string;
  movetype: string;
  defaultLocation: string | null;
  locations: ScacLocationInfo[];
}

export interface ScacInfoParams {
  movetype?: string;
  pronumber?: number;
}

export const scacInfoService = {
  async get(scac: string, params?: ScacInfoParams): Promise<ScacInfoResponse> {
    const { data } = await api.get<ScacInfoResponse>(
      `${BASE}/${encodeURIComponent(scac)}`,
      { params },
    );
    return data;
  },
};
